import { Component, input, computed } from '@angular/core';

@Component({
  selector: 'idel-infos-chip',
  templateUrl: './infos-chip.component.html',
  styleUrl: './infos-chip.component.scss',
})
export class InfosChipComponent {
  public readonly info = input.required<string>();
  public readonly infoPosition = input<'top' | 'bottom' | 'left' | 'right'>('top');
  public readonly size = input<'small' | 'medium' | 'large'>('medium');

  public readonly sizeStyle = computed<Record<string, string>>(() => {
    switch (this.size()) {
      case 'small':
        return {
          width: '1.5rem',
          height: '1.5rem',
          fontSize: '1.rem',
        };
      case 'large':
        return {
          width: '3rem',
          height: '3rem',
          fontSize: '2rem',
        };
      case 'medium':
        return {
          width: '2rem',
          height: '2rem',
          fontSize: '1.5rem',
        };
      default:
        return {
          width: '3rem',
          height: '3rem',
          fontSize: '2rem',
        };
    }
  });
}
